/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "destination",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "Dispatch",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        name: "DispatchId",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "origin",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "sender",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "Process",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        name: "ProcessId",
        type: "event",
    },
    {
        inputs: [],
        name: "defaultHook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultIsm",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        name: "delivered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "recipientAddress",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "body",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "customHookMetadata",
                type: "bytes",
            },
            {
                internalType: "contract IPostDispatchHook",
                name: "customHook",
                type: "address",
            },
        ],
        name: "dispatch",
        outputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "recipientAddress",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "body",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "defaultHookMetadata",
                type: "bytes",
            },
        ],
        name: "dispatch",
        outputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "recipientAddress",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "messageBody",
                type: "bytes",
            },
        ],
        name: "dispatch",
        outputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "latestDispatchedId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "process",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "recipientAddress",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "messageBody",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "customHookMetadata",
                type: "bytes",
            },
            {
                internalType: "contract IPostDispatchHook",
                name: "customHook",
                type: "address",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "recipientAddress",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "messageBody",
                type: "bytes",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "recipientAddress",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "messageBody",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "defaultHookMetadata",
                type: "bytes",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "recipientIsm",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "module",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "requiredHook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
export class IMailbox__factory {
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=IMailbox__factory.js.map